import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { CoreCOMService } from "../../services/com.service";

// import { FirebaseCloudMessaging } from "../../services/com/comEnvironmentFirebaseCloudMessaging";

@Component({
  selector: "app-debugview",
  templateUrl: "./debugview.component.html",
  styleUrls: ["./debugview.component.scss"],
})
export class DebugViewComponent implements OnInit {
  public pageTitle = "title";
  public pageBody = "body";

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _coreCOMService: CoreCOMService
  ) {
    _changeDetectorRef.detach();
  }

  /** Alle Änderungen der gebundenen Variablen an der Oberfläche neu darstellen. (Rerender) */
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error(
        "DebugViewComponent.PushChanges",
        "_changeDetectorRef.detectChanges (catch)",
        e
      );
    }
  }

  ngOnInit() {
    this.ShowErrorLog();
  }

  public CleanupLog() {
    const me = this;
    me._coreLogService.clear();
  }

  public ShowDebugLog() {
    const me = this;
    me.pageTitle = "DebugLog";
    me._coreLogService
      .readDebug()
      .then((text) => {
        me.pageBody = text;
        me.PushChanges();
      })
      .catch(() => {
        me.pageBody = "error only on mobile, for browser watch console";
        me.PushChanges();
      });
  }

  public ShowInfoLog() {
    const me = this;
    me.pageTitle = "InfoLog";
    me.pageBody = "Device Info:\r\n";
    const envClient = me._coreCOMService.environment.client;

    me.pageBody += "envClient.model: " + envClient.model + "\r\n";
    me.pageBody += "envClient.manufacturer: " + envClient.manufacturer + "\r\n";
    me.pageBody += "envClient.type: " + envClient.type + "\r\n";
    me.pageBody += "device.uuid: " + device.uuid + "\r\n";
    me.pageBody += "device.platform: " + device.platform + "\r\n";
    me.pageBody += "device.serial: " + device.serial + "\r\n";
    me.pageBody += "device.version: " + device.version + "\r\n";
    me._coreLogService
      .readInfo()
      .then((text) => {
        me.pageBody += "\r\nLog Info:\r\n" + text;
        me.PushChanges();
      })
      .catch(() => {
        me.pageBody = "error only on mobile, for browser watch console";
        me.PushChanges();
      });

    me.pageBody += "device.version: " + device.version + "\r\n";

    const fcm = this._coreCOMService.environment.firebaseCloudMessaging;
    fcm
      .getToken()
      .then((token) => {
        me.pageBody += "\r\n\r\nfcmPlugin Token:\r\n" + token;
        me.pageBody += "\r\n Ende fcmPlugin";
      })
      .catch((e) => {
        me.pageBody = "error fcmPlugin";
        me.pageBody += "\r\n Ende fcmPlugin";
      });

    me.pageBody += "\r\n Ende Log";
  }

  public ShowErrorLog() {
    const me = this;
    me.pageTitle = "ErrorLog";
    me._coreLogService
      .readError()
      .then((text) => {
        me.pageBody = text;
        me.PushChanges();
      })
      .catch(() => {
        me.pageBody = "error only on mobile, for browser watch console";
        me.PushChanges();
      });
  }
}
